// src/components/crm/CampaignDetailsModal.js

import React from 'react';
import { X } from 'lucide-react';
// s9campaign-2c8f6a17 — S9b (security audit #17): the stored campaign body is staff-written HTML
// that any Sales Consultant can save; rendering it raw let one staff member run script in another's
// browser. Same DOMPurify sanitizer as the inbox (keeps formatting, images and links).
import { sanitizeEmailHtml } from '../../utils/emailSanitizer';

const CampaignDetailsModal = ({ campaign, onClose }) => {
    if (!campaign) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-gray-800">Campaign Details</h2>
                    <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200"><X size={20} /></button>
                </div>

                <div className="flex-grow overflow-y-auto space-y-6">
                    <div>
                        <h3 className="font-semibold text-gray-600">Subject</h3>
                        <p>{campaign.subject}</p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-gray-600 mb-2">Email Body</h3>
                        <div className="tiptap-display border rounded-md p-4" dangerouslySetInnerHTML={{ __html: sanitizeEmailHtml(campaign.body || '') }} />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <h3 className="font-semibold text-gray-600 mb-2">Sent To ({campaign.recipients?.length || 0})</h3>
                            <div className="border rounded-md p-2 h-48 overflow-y-auto text-sm">
                                {campaign.recipients?.map((email, i) => <div key={i}>{email}</div>)}
                            </div>
                        </div>
                        <div>
                            <h3 className="font-semibold text-gray-600 mb-2">Opened By ({campaign.openers?.length || 0})</h3>
                            <div className="border rounded-md p-2 h-48 overflow-y-auto text-sm">
                                {campaign.openers?.map((email, i) => <div key={i}>{email}</div>)}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end pt-4 border-t mt-4">
                    <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Close</button>
                </div>
            </div>
        </div>
    );
};

export default CampaignDetailsModal;